import { ResponseError } from './codegen/base';

export function isResponse(error: unknown): error is ResponseError {
  return error instanceof ResponseError;
}

export async function getErrors(error: unknown) {
  if (isResponse(error)) {
    return error.response.json();
  }

  return null;
}

export async function getFieldErrors(error: unknown): Promise<Record<string, string>> {
  if (!isResponse(error)) return {};
  const body = await error.response.text();
  let errors: unknown;
  try {
    errors = JSON.parse(body);
  } catch (parseError) {
    if (parseError instanceof SyntaxError) return {};
    throw parseError;
  }
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) return {};

  const fields: Record<string, string> = {};
  Object.entries(errors).forEach(([field, messages]) => {
    if (typeof messages === 'string') {
      fields[field] = messages;
    } else if (Array.isArray(messages) && messages.every((message) => typeof message === 'string')) {
      fields[field] = messages.join(' ');
    }
  });
  return fields;
}
